import { render, staticRenderFns } from "./ChristmasCollections.vue?vue&type=template&id=afb9e30e&scoped=true"
import script from "./ChristmasCollections.vue?vue&type=script&lang=js"
export * from "./ChristmasCollections.vue?vue&type=script&lang=js"
import style0 from "./ChristmasCollections.vue?vue&type=style&index=0&id=afb9e30e&prod&scoped=true&lang=css"
import style1 from "./ChristmasCollections.vue?vue&type=style&index=1&id=afb9e30e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb9e30e",
  null
  
)

export default component.exports